import { Videos } from '../_app/cuchillo/components/Videos';
import { Acordions } from '../_app/cuchillo/components/Acordions';
import { Basics, isMobile, isTouch } from '../_app/cuchillo/core/Basics';
import Forms from '../_app/cuchillo/forms/FormValidator';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Page from '../_app/cuchillo/pages/Page';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import Cmp from '../windows/Cmp';
import { GetBy } from '../_app/cuchillo/core/Element';
import GridCanvas from '../components/GridCanvas';
import Scene from '../3D/Scene';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import Header from '../layout/Header';

export default class Home extends Page {
  _contentWrapper;

  constructor() {
    super();

    Videos.init();
    Acordions.init();
    Forms.init();

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.addEventListener(Basics.clickEvent, Cmp._calls.click);
    });
  }

  //SHOW
  beforeShow() {
    super.beforeShow();
    Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isTouch, multiplicator: 1 });
    Keyboard.mountPage(this.id);

    WebGLSketch.start();
    WebGLSketch.isInteractive = true;
    Scene.start();

    document.body.classList.add('--home');
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.directShow();
      Preloader.hide(() => {
        if (!isMobile) Header.showOpen();
        else Header.show();

        GridCanvas.start();
        this.afterShow();
      });
    } else {
      Wrap.directShow();
      this.afterShow();
    }
  }

  afterShow() {
    super.afterShow();
    Scroll.start();
    Scroll.show();
  }

  //HIDE
  beforeHide() {
    Keyboard.unmountPage(this.id);
    super.beforeHide();

    WebGLSketch.isInteractive = false;
    document.body.classList.remove('--home');
  }

  hide__effect() {
    Scroll.hide();
    Wrap.directHide();
    this.afterHide();
  }

  afterHide() {
    Scroll.dispose();
    super.afterHide();

    // WebGLSketch.stop();
    // Scene.stop();
  }

  //RESIZE
  resize() {
    super.resize();
    Acordions.resize();
  }

  //LOOP
  loop() {
    if (this._isActive) {
      super.loop();
    }
  }
}

ControllerPage._addPage('home', Home);
